import React from 'react';
import PropTypes from 'prop-types';
import {num2str} from '../../../../../utils/formater';

function Photos (props) {
  const photos = props.item.getPhotos();
  const rawItem = props.rawItem;
  const title = photos.size + ' ' + num2str(photos.size, ['фотография', 'фотографии', 'фотографий']);

  return (
    <td className='paper col-photos'>
      <a
        onClick={() => {
          props.eventClickAnnouncement(rawItem);
        }}
        target='_blank'
        href={props.item.getLink()}
        title={title}
      >
        <i className='icon icon-camera' />
        <div>{photos.size}</div>
      </a>
    </td>
  );
}

Photos.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  eventClickAnnouncement: PropTypes.func.isRequired
};

Photos.defaultProps = {};

export default Photos;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/Photos.jsx